/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Fallowing} from '../bioplanModels';
// @ts-ignore
import type {WriteFallowing} from '../bioplanModels';
/**
 * PlanningFallowingApi - axios parameter creator
 * @export
 */
export const PlanningFallowingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete fallowing by its identifier
     * @param {string} fallowingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsFallowingIdDelete: async (
      fallowingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fallowingId' is not null or undefined
      assertParamExists('fallowingsFallowingIdDelete', 'fallowingId', fallowingId);
      const localVarPath = `/fallowings/{fallowingId}`.replace(
        `{${'fallowingId'}}`,
        encodeURIComponent(String(fallowingId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get fallowing by its identifier
     * @param {string} fallowingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsFallowingIdGet: async (
      fallowingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fallowingId' is not null or undefined
      assertParamExists('fallowingsFallowingIdGet', 'fallowingId', fallowingId);
      const localVarPath = `/fallowings/{fallowingId}`.replace(
        `{${'fallowingId'}}`,
        encodeURIComponent(String(fallowingId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update fallowing for a site
     * @param {string} fallowingId
     * @param {WriteFallowing} writeFallowing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsFallowingIdPut: async (
      fallowingId: string,
      writeFallowing: WriteFallowing,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fallowingId' is not null or undefined
      assertParamExists('fallowingsFallowingIdPut', 'fallowingId', fallowingId);
      // verify required parameter 'writeFallowing' is not null or undefined
      assertParamExists('fallowingsFallowingIdPut', 'writeFallowing', writeFallowing);
      const localVarPath = `/fallowings/{fallowingId}`.replace(
        `{${'fallowingId'}}`,
        encodeURIComponent(String(fallowingId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeFallowing, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all fallowings for a site and plan
     * @param {string} [siteId]
     * @param {string} [planId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsGet: async (
      siteId?: string,
      planId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/fallowings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create fallowing for a site
     * @param {WriteFallowing} writeFallowing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsPost: async (
      writeFallowing: WriteFallowing,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'writeFallowing' is not null or undefined
      assertParamExists('fallowingsPost', 'writeFallowing', writeFallowing);
      const localVarPath = `/fallowings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeFallowing, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningFallowingApi - functional programming interface
 * @export
 */
export const PlanningFallowingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningFallowingApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete fallowing by its identifier
     * @param {string} fallowingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fallowingsFallowingIdDelete(
      fallowingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fallowingsFallowingIdDelete(fallowingId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFallowingApi.fallowingsFallowingIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get fallowing by its identifier
     * @param {string} fallowingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fallowingsFallowingIdGet(
      fallowingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fallowing>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fallowingsFallowingIdGet(fallowingId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFallowingApi.fallowingsFallowingIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update fallowing for a site
     * @param {string} fallowingId
     * @param {WriteFallowing} writeFallowing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fallowingsFallowingIdPut(
      fallowingId: string,
      writeFallowing: WriteFallowing,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fallowing>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fallowingsFallowingIdPut(
        fallowingId,
        writeFallowing,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFallowingApi.fallowingsFallowingIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all fallowings for a site and plan
     * @param {string} [siteId]
     * @param {string} [planId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fallowingsGet(
      siteId?: string,
      planId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Fallowing>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fallowingsGet(siteId, planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFallowingApi.fallowingsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create fallowing for a site
     * @param {WriteFallowing} writeFallowing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fallowingsPost(
      writeFallowing: WriteFallowing,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fallowing>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fallowingsPost(writeFallowing, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFallowingApi.fallowingsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningFallowingApi - factory interface
 * @export
 */
export const PlanningFallowingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningFallowingApiFp(configuration);
  return {
    /**
     *
     * @summary Delete fallowing by its identifier
     * @param {PlanningFallowingApiFallowingsFallowingIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsFallowingIdDelete(
      requestParameters: PlanningFallowingApiFallowingsFallowingIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .fallowingsFallowingIdDelete(requestParameters.fallowingId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get fallowing by its identifier
     * @param {PlanningFallowingApiFallowingsFallowingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsFallowingIdGet(
      requestParameters: PlanningFallowingApiFallowingsFallowingIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Fallowing> {
      return localVarFp
        .fallowingsFallowingIdGet(requestParameters.fallowingId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update fallowing for a site
     * @param {PlanningFallowingApiFallowingsFallowingIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsFallowingIdPut(
      requestParameters: PlanningFallowingApiFallowingsFallowingIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Fallowing> {
      return localVarFp
        .fallowingsFallowingIdPut(requestParameters.fallowingId, requestParameters.writeFallowing, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all fallowings for a site and plan
     * @param {PlanningFallowingApiFallowingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsGet(
      requestParameters: PlanningFallowingApiFallowingsGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Fallowing>> {
      return localVarFp
        .fallowingsGet(requestParameters.siteId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create fallowing for a site
     * @param {PlanningFallowingApiFallowingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fallowingsPost(
      requestParameters: PlanningFallowingApiFallowingsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Fallowing> {
      return localVarFp
        .fallowingsPost(requestParameters.writeFallowing, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for fallowingsFallowingIdDelete operation in PlanningFallowingApi.
 * @export
 * @interface PlanningFallowingApiFallowingsFallowingIdDeleteRequest
 */
export interface PlanningFallowingApiFallowingsFallowingIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFallowingApiFallowingsFallowingIdDelete
   */
  readonly fallowingId: string;
}

/**
 * Request parameters for fallowingsFallowingIdGet operation in PlanningFallowingApi.
 * @export
 * @interface PlanningFallowingApiFallowingsFallowingIdGetRequest
 */
export interface PlanningFallowingApiFallowingsFallowingIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFallowingApiFallowingsFallowingIdGet
   */
  readonly fallowingId: string;
}

/**
 * Request parameters for fallowingsFallowingIdPut operation in PlanningFallowingApi.
 * @export
 * @interface PlanningFallowingApiFallowingsFallowingIdPutRequest
 */
export interface PlanningFallowingApiFallowingsFallowingIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFallowingApiFallowingsFallowingIdPut
   */
  readonly fallowingId: string;

  /**
   *
   * @type {WriteFallowing}
   * @memberof PlanningFallowingApiFallowingsFallowingIdPut
   */
  readonly writeFallowing: WriteFallowing;
}

/**
 * Request parameters for fallowingsGet operation in PlanningFallowingApi.
 * @export
 * @interface PlanningFallowingApiFallowingsGetRequest
 */
export interface PlanningFallowingApiFallowingsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFallowingApiFallowingsGet
   */
  readonly siteId?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFallowingApiFallowingsGet
   */
  readonly planId?: string;
}

/**
 * Request parameters for fallowingsPost operation in PlanningFallowingApi.
 * @export
 * @interface PlanningFallowingApiFallowingsPostRequest
 */
export interface PlanningFallowingApiFallowingsPostRequest {
  /**
   *
   * @type {WriteFallowing}
   * @memberof PlanningFallowingApiFallowingsPost
   */
  readonly writeFallowing: WriteFallowing;
}

/**
 * PlanningFallowingApi - object-oriented interface
 * @export
 * @class PlanningFallowingApi
 * @extends {BaseAPI}
 */
export class PlanningFallowingApi extends BaseAPI {
  /**
   *
   * @summary Delete fallowing by its identifier
   * @param {PlanningFallowingApiFallowingsFallowingIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFallowingApi
   */
  public fallowingsFallowingIdDelete(
    requestParameters: PlanningFallowingApiFallowingsFallowingIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFallowingApiFp(this.configuration)
      .fallowingsFallowingIdDelete(requestParameters.fallowingId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get fallowing by its identifier
   * @param {PlanningFallowingApiFallowingsFallowingIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFallowingApi
   */
  public fallowingsFallowingIdGet(
    requestParameters: PlanningFallowingApiFallowingsFallowingIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFallowingApiFp(this.configuration)
      .fallowingsFallowingIdGet(requestParameters.fallowingId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update fallowing for a site
   * @param {PlanningFallowingApiFallowingsFallowingIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFallowingApi
   */
  public fallowingsFallowingIdPut(
    requestParameters: PlanningFallowingApiFallowingsFallowingIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFallowingApiFp(this.configuration)
      .fallowingsFallowingIdPut(requestParameters.fallowingId, requestParameters.writeFallowing, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all fallowings for a site and plan
   * @param {PlanningFallowingApiFallowingsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFallowingApi
   */
  public fallowingsGet(
    requestParameters: PlanningFallowingApiFallowingsGetRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFallowingApiFp(this.configuration)
      .fallowingsGet(requestParameters.siteId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create fallowing for a site
   * @param {PlanningFallowingApiFallowingsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFallowingApi
   */
  public fallowingsPost(requestParameters: PlanningFallowingApiFallowingsPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningFallowingApiFp(this.configuration)
      .fallowingsPost(requestParameters.writeFallowing, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
